package com.kinoshazam.screens.appInfo.compact

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.kinoshazam.config.getPlatformConfig
import com.kinoshazam.config.isAndroid
import com.kinoshazam.config.isIOS
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.about
import kinoshazam.resources.generated.resources.about_crawl_body
import kinoshazam.resources.generated.resources.about_crawl_title
import kinoshazam.resources.generated.resources.back
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.appInfo.AppInfoMVIAction
import presentation.screens.appInfo.AppInfoState
import presentation.screens.appInfo.AppInfoViewModel

@Composable
fun AppInfoContentHost() {
    val viewModel = koinViewModel<AppInfoViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()
    AppInfoContent(state = state, onAction = viewModel::onAction)
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun AppInfoContent(
    state: AppInfoState,
    onAction: (AppInfoMVIAction) -> Unit,
) {
    val isMobile = remember {
        val platform = getPlatformConfig().platform
        platform.isAndroid() || platform.isIOS()
    }
    val title = stringResource(Res.string.about_crawl_title)
    val body = stringResource(Res.string.about_crawl_body, state.appVersion)

    Scaffold(
        topBar = {
            TopAppBar(
                title = {
                    Text(
                        text = stringResource(Res.string.about),
                        color = UiKitTheme.colors.color_2
                    )
                },
                navigationIcon = {
                    Image(
                        painter = painterResource(Res.drawable.back),
                        colorFilter = ColorFilter.tint(UiKitTheme.colors.color_1),
                        contentDescription = "Back",
                        modifier = Modifier
                            .padding(horizontal = 16.dp)
                            .clickable {
                                onAction(AppInfoMVIAction.onBackClicked)
                            }
                    )
                },
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = UiKitTheme.colors.color_3,
                ),
            )
        },
        containerColor = UiKitTheme.colors.color_3,
        contentWindowInsets = WindowInsets(0, 0, 0, 0),
        content = { paddingValues ->
            Box(modifier = Modifier.fillMaxSize()) {
                if (isMobile) {
                    AuroraAboutPanel(
                        title = title,
                        body = body,
                        contentTopPadding = paddingValues.calculateTopPadding(),
                    )
                } else {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(paddingValues),
                    ) {
                        CrawlAboutPanel(
                            title = title,
                            body = body,
                        )
                    }
                }
            }
        }
    )
}
